import modelBaseV2 from "../model-base-v2.model";

const SEAOPOSMMasterModel = {
  addSEAOHierachyDetail: function (hierachyObj) {
    return modelBaseV2.post(
      '/api/seao/posmMaster/insertOrUpdateCate',
      {
        body: hierachyObj,
      }
    );
  },
  getSEAOHierachyTreeByLevel: function (fromLevel, toLevel) {
    return modelBaseV2.get(
      '/api/seao/posmMaster/getHierarchyTree',
      {
        params: { fromLevel, toLevel },
      }
    );
  },
  getSEAOHierachyTreeByParentCode: function (parentId) {
    return modelBaseV2.get(
      '/api/seao/posmMaster/getCatesByParentId',
      {
        params: { parentId },
      }
    );
  },
  addSEAOPosmStorageLocation: function (storageObj) {
    return modelBaseV2.post('/api/seao/posmMaster/storageLocation',
      {
        body: { ...storageObj }
      }
    );
  },
  getSEAOCommonForPopup: function (params) {
    return modelBaseV2.get('/api/seao/posmMaster/getCommonCodeNameForPopup',
      {
        params: { ...params }
      }
    )
  },
  deleteSEAOWarehouse: function (warhouseId) {
    return modelBaseV2.post('/api/seao/posmMaster/storageLocation',
      {
        body: { WarehouseId: warhouseId, Type: "Warehouse", Action: "DELETE", CateName: "test" }
      })
  },
  updateSEAOWarehouse: function (warhouseId, warehouseName) {
    return modelBaseV2.post('/api/seao/posmMaster/storageLocation',
      {
        body: { WarehouseId: warhouseId, Type: "Warehouse", Action: "UPDATE", CateName: warehouseName }
      })
  },

  getSEAOVendorList: function (params) {
    return modelBaseV2.get('/api/seao/posmMaster/goodsReceiveVendorGetList', { params })
  },

  saveSEAOVendor: function (body) {
    return modelBaseV2.post('/api/seao/posmMaster/receiveVendorSave', { body });
  },
}

export const {
  addSEAOHierachyDetail,
  getSEAOHierachyTreeByLevel,
  getSEAOHierachyTreeByParentCode,
  addSEAOPosmStorageLocation,
  getSEAOCommonForPopup,
  deleteSEAOWarehouse,
  updateSEAOWarehouse,
  getSEAOVendorList,
  saveSEAOVendor
} = SEAOPOSMMasterModel;